import { useTranslation } from '@/hooks/support/translate';
import classNames from 'classnames';
import { FC } from 'react';

interface MissionHubHeaderProps {
    className?: string;
    title: string;
    caption?: string;
    actions?: React.ReactNode;
}
export const MissionHubHeader: FC<MissionHubHeaderProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className={classNames(props.className, 'flex flex-col md:flex-row justify-between items-center')}>
            <div className="flex flex-col space-y-3 text-center text-white md:text-left title md:w-1/2 lg:w-2/3">
                <div className="md:t__heading--h5 t__heading--h6">{props.title}</div>
                {props.caption && (
                    <div className="mt-4 md:t__body--b2 t__body--b3 md:pt-0 text-grey-20">{props.caption}</div>
                )}
            </div>
            <div className="flex gap-8">{props.actions}</div>
        </div>
    );
};
